var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScraperIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.16667H2.16667V0.5C1.25 0.5 0.5 1.25 0.5 2.16667ZM0.5 8.83333H2.16667V7.16667H0.5V8.83333ZM3.83333 15.5H5.5V13.8333H3.83333V15.5ZM0.5 5.5H2.16667V3.83333H0.5V5.5ZM8.83333 0.5H7.16667V2.16667H8.83333V0.5ZM13.8333 0.5V2.16667H15.5C15.5 1.25 14.75 0.5 13.8333 0.5ZM2.16667 15.5V13.8333H0.5C0.5 14.75 1.25 15.5 2.16667 15.5ZM0.5 12.1667H2.16667V10.5H0.5V12.1667ZM5.5 0.5H3.83333V2.16667H5.5V0.5ZM7.16667 15.5H8.83333V13.8333H7.16667V15.5ZM13.8333 8.83333H15.5V7.16667H13.8333V8.83333ZM13.8333 15.5C14.75 15.5 15.5 14.75 15.5 13.8333H13.8333V15.5ZM13.8333 5.5H15.5V3.83333H13.8333V5.5ZM13.8333 12.1667H15.5V10.5H13.8333V12.1667ZM10.5 15.5H12.1667V13.8333H10.5V15.5ZM10.5 2.16667H12.1667V0.5H10.5V2.16667ZM3.83333 12.1667H12.1667V3.83333H3.83333V12.1667ZM5.5 5.5H10.5V10.5H5.5V5.5Z",
    fill: "#535A60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScraperIcon);
export default __webpack_public_path__ + "static/media/scraperIcon.48701a5169051a2c0d4b8e3920467567.svg";
export { ForwardRef as ReactComponent };